import moment from 'moment'

export default {

  computed: {
    limit: {
      get () {
        return this.getListLimit
      },
      set (value) {
        this.setListLimit(value)
      }
    },

    tableColumns: {
      get () {
        return this.getColumns
      },
      set (value) {
        this.setColumns(value)
      }
    },

    showPagination () {
      return this.totalPages > 1
    },

    limitOptions () {
      return this.getLimitOptions()
    }
  },

  methods: {
    getProfiles (tools) {
      if (typeof tools.Akeeba !== 'undefined') {
        if (typeof tools.Akeeba.profiles !== 'undefined') {
          if (tools.Akeeba.profiles.length > 0) {
            return tools.Akeeba.profiles
          }
        }
      }

      return []
    },

    getProfileName (tools, id) {
      let profileId = parseInt(id)

      if (profileId < 1) {
        return ''
      }

      let profiles = this.getProfiles(tools)

      if (profiles.length > 0) {
        let profile = profiles.find(e => { return parseInt(e.id) === profileId })

        if (profile !== undefined && profile.description !== undefined) {
          return profile.description
        }
      }

      return ''
    },

    getLimitOptions () {
      return [
        { value: 25, text: '25' },
        { value: 50, text: '50' },
        { value: 100, text: '100' },
        { value: 200, text: '200' }
      ]
    },

    changeSearch () {
      this.goToPage(1)
    },

    sortColumn (column) {
      if (this.sort === column) {
        if (this.dir === 'asc') {
          this.dir = 'desc'
        } else {
          this.dir = 'asc'
        }
      } else {
        this.sort = column
      }

      this.goToPage(1)
    },

    limitChange (event) {
      this.setListLimit(event)
      this.goToPage(1)
    },

    getConfigValue (config, key, defaultValue) {
      if (config === null) {
        return defaultValue
      }

      if (typeof config[key] !== 'undefined') {
        return config[key]
      }

      return defaultValue
    },

    transformTime (time, tz, format) {
      if (typeof format === 'undefined') {
        format = 'DD.MM.YYYY HH:mm'
      }
      return moment(time).add(parseInt(tz), 'hours').format(format)
    },

    toggleBodyClass (addRemoveClass, className) {
      const el = document.body

      if (addRemoveClass === 'addClass') {
        el.classList.add(className)
      } else {
        el.classList.remove(className)
      }
    }
  }
}
